var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{style:({ minWidth: _vm.minWidth + 'px' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }